import { signal } from '@preact/signals';
import { emptyRateInputs, type RateInputsState } from '@/lib/rate-inputs.js';

/** What the current tiers were rated with. `useRerate` replays it verbatim. */
export const rateInputs = signal<RateInputsState>(emptyRateInputs);

export function resetRateInputs(): void {
  rateInputs.value = emptyRateInputs;
}
